import React from 'react';
import RequestText from 'app/containers/RequestText';

export default function SuccessRequestText({ requestType }) {
  return <RequestText requestType={requestType} requestState="success" />;
}
